import React from "react";

import {useSiteContext} from "@client/site/context";
import {server} from "@reactivated";
import type * as imagesType from "@reactivated/images";

interface Props {
    className?: string;
    image: keyof typeof server.core.IMAGE_MAP;
    title: string | null;
}

export const Image = React.memo((props: Props) => {
    const {realm} = useSiteContext();

    if (realm == "app") {
        throw new Error("Images cannot be used on the app. Use <Graphic />.");
    }

    const componentName = server.core.IMAGE_MAP[props.image];

    if (import.meta.env.SSR) {
        const images = import.meta.glob("@reactivated/images", {eager: true})[
            "/client/generated/images/index.tsx"
        ] as typeof imagesType;

        const Component = images[componentName];
        return (
            <Component title={props.title ?? undefined} className={props.className} />
        );
    } else {
        return <svg suppressHydrationWarning dangerouslySetInnerHTML={{__html: ""}} />;
    }
});
